import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { AppRole } from "./types";
import { useAuth } from "./useAuth";

type RequireAuthProps = {
  allowedRoles?: AppRole[];
};

export function RequireAuth({ allowedRoles }: RequireAuthProps) {
  const { session } = useAuth();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles && !allowedRoles.includes(session.appRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
